import React from "react";

const Rhold = ({head, sub, list1, list2, list3, img}) =>{
    return(
        <section className="rHold">
            <div className="text">
                <h2>{head}</h2>
                <p>{sub}</p>
                <ul>
                    <li><div className="red"></div>{list1}</li>
                    <li><div className="red"></div>{list2}</li>
                    <li><div className="red"></div>{list3}</li>
                </ul>
            </div>
            <div className="img"><img src={img} alt="" /></div>
        </section>
    )
}

export default Rhold;